import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Tooltip, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  typography: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "100%",
    display: "block",
  },
}));

const TruncatedText = ({
  text,
  variant,
  color,
  fw,
  fs,
  tooltipPlacement,
  className,
}) => {
  const classes = useStyles();

  const textRef = useRef(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (textRef.current) {
        setIsOverflowed(
          textRef.current.scrollWidth > textRef.current.clientWidth,
        );
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [text]);

  return (
    <Tooltip
      title={isOverflowed ? text : ""}
      arrow
      placement={tooltipPlacement}
    >
      <Typography
        noWrap
        ref={textRef}
        className={clsx(classes.typography, className && className)}
        color={color}
        variant={variant}
        fontSize={fs}
        fontWeight={fw}
      >
        {text}
      </Typography>
    </Tooltip>
  );
};

TruncatedText.defaultProps = {
  text: "-",
  className: "",
  variant: "body2",
  tooltipPlacement: "bottom",
};

TruncatedText.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fw: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variant: PropTypes.string,
  className: PropTypes.string,
  tooltipPlacement: PropTypes.string,
};

export default TruncatedText;
